module.exports = __webpack_public_path__ + "static/media/55pic.298fa7a4.jpg";